<template>
	<div id="subsidiaryLedger" >
		 <transition name="slide-fade">
			<subject-tree v-show='isSubjectShow' @onHandleSubjectIdChange='onHandleSubjectIdChange' @getSubjectType = 'getSubjectType'
			:formData='formData'
			:refreshTreeBar='refreshTreeBar'
			>
			</subject-tree>
		 </transition>
		<div class="public-content mr300" ref='mr300Css'>
			<!-- 公共form表单样式 -->
			<div class="form-item-public clearfix">
				<el-form inline label-position="left">
					<el-form-item label="明细账">
						<accounting-period @defaultTime='defaultTime' ref="period_ref"></accounting-period>
					</el-form-item>
					<el-form-item label="科目名称">
						<el-select
							size="mini"
							placeholder="请选择"
							v-model="form.subjectId" filterable>
						    <el-option
						    	v-for="item in subjectData"
						    	:key="item.id"
						    	:label="item.labels"
						    	:value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="mini" class='minButton' @click='getTableList'>搜索</el-button>
					</el-form-item>

					<el-form-item class="fr">
						<el-checkbox  @change="handleCheck"  v-model='isChildrenShow' class="checkBox">显示数量</el-checkbox>
							<!-- 打印-导出 -->
						 <div v-for="item in buttonList" style='display: inline-block;padding-left:5px;margin-right: 10px;' :key='item.id'>
				                  <el-button size="mini" @click='handleButtonPrint(item.function)'>
				                    {{item.name}} </i>
				                  </el-button>
				          </div>
						<el-button
							class=""
							size="mini"
							@click="handleSubjectShow" ref='handleButtons'>
							<span v-if='handleSpanShow'>隐藏科目列表</span>
							<span v-else>显示科目列表</span>
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<public-table  :table="tableData" v-if="refresh">
				<template slot-scope="props" slot="number">
					<a href="javascript:;" v-text="props.scope.row.number" @click="handleModify(props.scope.row)"></a>
				</template>
			</public-table>

			<!-- 修改凭证  -->
			<edit-voucher :visible.sync="XG_voucherShow" :row="rows" @on-close-dialog="cancel" v-if="XG_voucherShow" :openButton_s='openButton_s'></edit-voucher>
		</div>
		<!-- 连续打印弹框 -->
		<el-dialog
			title='连续打印'
			class='default-dialog'
			:visible.sync="isShowPrint"
			:close-on-click-modal="false"
			width='380px'>
			<el-form ref="form" :model="form">
				<el-form-item label="打印方向：">
					<el-radio-group v-model="dy_form.rotate">
				    	<el-radio label="1">纵向</el-radio>
				    	<el-radio label="2">横向</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item label="显示页码：">
					<el-checkbox v-model="dy_form.showPage">显示打印页码</el-checkbox>
				</el-form-item>
        <el-form-item label="账簿封面：">
					<el-radio-group v-model="dy_form.isCover">
				  	<el-radio :label="true">
            <span style="position:relative;">
              <span>打印</span>
              <img src="../../../static/img/default_img.png" alt="" class="default_img" @click="showCover = true" style="width: 14px;position: absolute;left: 32px;top: 1px;cursor: pointer;">
            </span>
            </el-radio>
				  	<el-radio :label="false">不打印</el-radio>
				  </el-radio-group>
				</el-form-item>
				<el-form-item  label="科目类别：">
					<el-select v-model="dy_form.subjectType" size="mini">
						<el-option
							v-for="item in subjectType"
							:key="item"
							:label="item"
							:value="item"
            >
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="科目级别：">
					<el-select v-model="dy_form.level" size="mini">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
		    	<el-button size="small" class="secondaryButton" @click="isShowPrint = false">取 消</el-button>
			    <el-button size="small"class='minButton' @click="confirm">打 印</el-button>
		  	</span>
		</el-dialog>

		<!-- 导出 -->
		<public-export :exportDialogShow.sync="exportDialogShow" @clickExport='clickExport'></public-export>

    <!-- 查看封面 -->
    <el-dialog :visible.sync="showCover" width="900px" :close-on-click-modal="true" @close="showCover = false" custom-class="coverDialog" append-to-body>
      <img src="../../../static/img/cover2.jpg" alt="" style="width:100%;">
		</el-dialog>
	</div>

</template>

<script>
	import publicExport from '@/components/dialog/publicExport'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import SubjectTree from '@/components/subject/SubjectSiderbar'
	import publicTable from '@/components/publicTable'
	import printOperation from '@/components/print'
	import {currencys} from '@/assets/utils/currencyFormat'
	import editVoucher from '@/components/table/editVoucher'
export default {
	data(){
		return {
			exportDialogShow:false,
			openButton_s:false,  // 显示标记按钮
			refreshTreeBar:false,
			formData:{
				start:"",
				end:""
			},
			isFirstActive: false,
			subjectType: [],   // 科目类别
			printForm: {        // 打印参数
				data: {
					start: '',
					end: '',
					subjectId: '',
					isTotal: true
				},
				url: '/createPDF/printTotalDetail',
				continuityUrl: '/createPDF/printTotalDetail'
			},
			dy_form: {
				rotate: "1",
				showPage: false,
				level: '5',
				subjectType: '全部',
        isCover:false
			},
			superSubjectId:'', // 科目ID
			isShowPrint: false,      // 连续打印弹框
			printParams: {},  // 打印数据
			options: [{
					value: '1',
					label: '一级'
				},{
					value: '2',
					label: '二级'
				},{
					value: '3',
					label: '三级'
				},{
					value: '4',
					label: '四级'
				},{
					value: '5',
					label: '五级'
				}],
			isFormChange: true,		// 初始获取会计期间和科目ID时获取列表数据
			isLoad: false,			// 是否获取列表
			refresh: true,
			isChildrenShow: false,
			handleSpanShow: true,
			isSubjectShow: true,        // 科目列表是否显示
			form: { // 筛选
				subjectId: '',
				start:'' ,
				end: '',
			},
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '日期',
					value: 'date',
					show: 'normal',
          width: 150
				},{
					label: '凭证字号',
					value: 'number',
					width: 90,
					show: 'template'
				},{
					label: '摘要',
					value: 'summary',
					show: 'normal',
				},{
					label: '借方',
					value: 'debitMoney',
					show: 'normal',
					name : "changeable",
					showChild : false,
					formatter: this.formatter,
					children:[
						{
							label: '数量',
							value: 'debitAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'debitUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'debitMoney',
							show: 'normal'
						}
					]
				},{
					label: '贷方',
					value: 'creditorMoney',
					show: 'normal',
					name : "changeable",
					showChild : false,
					formatter: this.formatter,
					children:[
								{
							label: '数量',
							value: 'creditorAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'creditorUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'creditorMoney',
							show: 'normal'
						}
					]
				},{
					label: '方向',
					value: 'creditDirection',
					show: 'normal',
					width: 50,
				},{
					label: '余额',
					value: 'remainingSum',
					show: 'normal',
					name : "changeable",
					formatter: this.formatter,
					showChild : false,
					children:[
								{
							label: '数量',
							value: 'remainingAmount',
							show: 'normal'
						},{
							label: '单价',
							value: 'remainingUnitPrice',
							show: 'normal'
						},{
							label: '金额',
							value: 'remainingSum',
							show: 'normal'
						}
					]
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			},

			XG_voucherShow: false, //修改凭证modal
			rows:{},				//列表数据
			buttonList:[],      // 按钮列表
      showCover:false, // 封面弹框
		}
	},
	components:{
		accountingPeriod,
		SubjectTree,
		publicTable,
		printOperation,
		editVoucher,
		publicExport
	},
	created(){
		this.getAllSubject();
		this.getButtonAuthorize();
	},
	activated() {
    const queryInfo = this.$route.query;
		if(queryInfo.subjectId) {
			this.form.subjectId = queryInfo.subjectId;
      this.form.start = queryInfo.start || this.form.start;
      this.form.end = queryInfo.end || this.form.end;
			this.getTableList();
      if(this.form.start && this.form.end) {
        this.refreshTreeBar = true;
        this.$nextTick(()=> {
          this.refreshTreeBar = false;
          let _start = this.form.start.toString().slice(0,4) + '-' + this.form.start.toString().slice(4);
          let _end = this.form.end.toString().slice(0,4) + '-' + this.form.end.toString().slice(4);
          this.$refs.period_ref.setTimeRange(_start,_end)
        })
      }
		}else {
			if(this.getClickCache&&this.isFirstActive) {
				this.getAllSubject();
				this.getTableList();
			}
			this.isFirstActive = true;
		}

	},
	computed : {
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		},
		//获取tableData.config名字为changeable的数据
		getTableDatas(){
			let getTableDatas = this.tableData.config.filter((item)=>{
				if(item.name == "changeable"){
					this.tableData.data.forEach((item)=>{
						if(item.debitMoney && item.debitAmount){
							item.debitUnitPrice = (Number(item.debitMoney)/Number(item.debitAmount)).toFixed(2);
						}
						if(item.creditorMoney && item.creditorAmount){
							item.creditorUnitPrice = (Number(item.creditorMoney)/Number(item.creditorAmount)).toFixed(2);
						}
						if(item.remainingSum && item.remainingAmount){
							item.remainingUnitPrice = (Number(item.remainingSum)/Number(item.remainingAmount)).toFixed(2);
						}
					})
					return item;
				}
			})
			return getTableDatas;
		},
		// 科目
		subjectData() {
			return this.$store.state.getSubjectId.AllSubjectList
		}
	},
	methods:{
		init(){
			//快速访问

		},
		// 导出
		clickExport(data) {
			if(data.exportType==1) {
				this.handleExport('Excel',data.exportScope);
			}else {
				this.handleExport('PDF',data.exportScope);
			}
		},
		// 导出功能
	      handleExport(type,isSubject) {
	          let params = {
	            cid: sessionStorage.cid,
	            token: sessionStorage.token,
	          }
	           if(type!='Excel') {
	              params = Object.assign(params,this.printForm.data);
	              params.type="1";
	          }else {
	          	params = Object.assign(params,this.printForm.data);
	          }
	          // 全部不传科目id
	          if(isSubject!=1) {
	          	params.subjectId = "";
	          }

			params.isAmount = this.isChildrenShow;
	          const router =this.$router.resolve({
	          path: type=='Excel'?'/export/exportTotalAccount':'createPDF/printTotalDetail',
	          query: params
	        })
	        window.location.href = this.$rootUrl + router.href;
	      },
		 // 按钮点击处理
	     handleButtonPrint(type) {
	     	switch(type) {
	     		case 'print_single':
	     			this.printTotalDetail('1');
	     			break;
	     		case 'print_double':
	     			this.openPrintDialog();
	     			break;
	     		case 'import':
	     			this.exportDialogShow = true;
	     			break;
	     		default:
	     			return;
	     			break;
	     	}
	     },
		 // 获取打印导出导入按钮权限
	      getButtonAuthorize() {
	        const _ = this;
	        let params={
	          permissions:'ac:books:detail:print_single,ac:books:detail:print_double,ac:books:detail:import'
	        }
	         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	              _.buttonList = res.data.data;
	            }
	         })
	      },
	       // 确认连续打印
		confirm() {
			this.isShowPrint = false;
			this.printParams = Object.assign({}, this.printParams, this.dy_form);
			this.printTotalDetail('2');
		},
	     // 连续打印
	     openPrintDialog() {
	     	this.isShowPrint = true;
	     },
	       // 打印&&连续打印
		printTotalDetail (type) {
			if(this.printForm.data.subjectId) {
				this.superSubjectId = this.printForm.data.subjectId;
			}
			if(this.superSubjectId) {
				if(type == 2) {
					this.printForm.data.subjectId = '';
				}else if(type == 1){
					this.printForm.data.subjectId = this.superSubjectId;
				}
			}
			this.printParams = Object.assign({}, this.printParams, this.printForm.data, {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
				isAmount:this.isChildrenShow,
			})
			const router = this.$router.resolve({
				path: type === '1' ? this.printForm.url : this.printForm.continuityUrl,
				query: this.printParams
			})
			window.open(this.$rootUrl + router.href, '_blank')
		},
		// 表格格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'debitMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'creditorMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'remainingSum':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);

					}
					break;
			}
		},
		// 获取科目类别
		getSubjectType(data) {
			let lsDate = JSON.parse(JSON.stringify(data));
			this.subjectType = lsDate;
		},
		// 科目树发过来的数据
		onHandleSubjectIdChange(data) {
			if(data.id) {
				this.form.subjectId = data.id;
				this.printForm.subjectId = data.id;
				this.getTableList();
			}
		},
		// 查询所有科目
		getAllSubject () {
				this.$store.dispatch('getAllSubject')
				if(this.subjectData) {
					this.form.subjectId = this.subjectData[0].id;
				}
		},
		// 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				start: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
			})
			this.formData = Object.assign(this.formData,{
				start: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
			})
			this.isLoadTableList(this.form);
		},
		// 是否加载Table列表
		isLoadTableList (val) {
			for (const i in val) {
				this.$set(this.printForm.data, i, val[i]);
				if(!val[i]) {
					this.isLoad = false;
					break;
				} else {
					this.isLoad = true;
				}
			}
			(this.isFormChange && this.isLoad) && this.getTableList();
		},
		// 获取表格数据
		getTableList(){
			try{
				this.tableData.loading=true;
				this.$http.post('subsidiaryLedger/tablelist',this.form).then(res=>{
					this.isFormChange = false;
					this.tableData.data = res.data.data.map(item => {
						for (const i in item) {
							if (typeof item[i] === 'number') {
								item[i] = item[i] === 0 ? '' : item[i];
							}
						}
						if(item.debitMoney && item.debitAmount){
							item.debitUnitPrice = (Number(item.debitMoney)/Number(item.debitAmount)).toFixed(2);
						}
						if(item.creditorMoney && item.creditorAmount){
							item.creditorUnitPrice = (Number(item.creditorMoney)/Number(item.creditorAmount)).toFixed(2);
						}
						if(item.remainingSum && item.remainingAmount){
							item.remainingUnitPrice = (Number(item.remainingSum)/Number(item.remainingAmount)).toFixed(2);
						}
						return item;
					})
					this.tableData.loading=false;
				})
			}catch(e){
				this.tableData.loading=false;
			}
		},
		// checkbox点击事件
		handleCheck(){
			this.getTableDatas.forEach((item)=>{
				item.showChild = this.isChildrenShow;
			})
			if(!this.isChildrenShow){
				this.refresh = false;
				this.$nextTick(()=>{
					this.refresh = true;
				})
			}
		},
		handleSubjectShow() {
			this.isSubjectShow = !this.isSubjectShow;
			if(!this.isSubjectShow) {
				this.$refs.mr300Css.style.marginRight = '0px';
				this.$refs.mr300Css.style.transition = 'margin-right .2s';
				this.handleSpanShow = false;
			}else {
				this.$refs.mr300Css.style.marginRight = '300px';
				this.handleSpanShow = true;

			}
		},




		///凭证列表修改开始打啊大 ---------------------------------------------------
		// 列表修改操作
		handleModify(row){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.openButton_s = true;
			_.XG_voucherShow = true;
			_.rows = row;
		},
		cancel(val){
			this.XG_voucherShow = val;
			this.refreshTreeBar = !this.refreshTreeBar;
			this.getTableList();
			this.openButton_s = false;
		},
		successEdit(val){//修改成功后的回调
			if(val){
				this.getTableList();
			}
		},
		///凭证列表修改结束 ---------------------------------------------------
	},
	mounted() {

	},
	watch: {
		subjectData(val , oldVal){
			if(this.$route.query.subjectId) {
				return;
			}else {
				this.form.subjectId = val[0].id;
			}
		},
		'form.subjectId': {
			deep: true,
			handler (val, newVal) {
				if (val) {
					this.isLoadTableList(this.form);
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
	#subsidiaryLedger{
		.mr300 {
			margin-right: 300px;
		}
		.slide-fade-enter-active {
		  transition: all .1s ease;
		}
		.slide-fade-leave-active {
		  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		}
		.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active for below version 2.1.8 */ {
		  transform: translateX(20px);
		  opacity: 0;
		}
		.el-tabs__item {
			padding: 0 15px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/subsidiaryLedger.vue